import React from "react";
import PropTypes from "prop-types";
import { FaCut, FaEllipsisV, FaTrash } from "react-icons/fa";
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function SoundDropdownMenu({ className, onAdjust, onDelete }) {
  const { t } = useTranslation(["common"]);
  return (
    <Menu isLazy>
      <MenuButton
        className={className}
        as={IconButton}
        icon={<FaEllipsisV />}
        variant="unstyled"
      />
      <Portal>
        <MenuList zIndex="docked">
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            icon={<FaTrash />}
          >
            {t("delete")}
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onAdjust();
            }}
            icon={<FaCut />}
          >
            {t("adjust")}
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  );
}

SoundDropdownMenu.propTypes = {
  onAdjust: PropTypes.func,
  onDelete: PropTypes.func,
  className: PropTypes.string,
};

export default SoundDropdownMenu;
